export default (text: string, from = "-", to = " "): string =>
  text ? text.split(from).join(to) : text;
